module.exports = __webpack_public_path__ + "static/media/a4.23e41118.png";